import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Webcam } from '../models/webcam.model';


@Injectable({
  providedIn: 'root'
})
export class WebcamService {
  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {Webcam} webcam
   * @return {Promise<any>}
   */
  putWebcam(airportID: number, webcam: Webcam): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/webcam/${webcam.webcamId}`;
    try {
      const BODY = this._getWebcamJSON(webcam);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} airportID
   * @param {Webcam} webcam
   * @return {Promise<any>}
   */
  postWebcam(airportID: number, webcam: Webcam): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/webcam/`;
    try {
      const BODY = this._getWebcamJSON(webcam);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} webcamID
   * @return {Promise<any>}
   */
  deleteWebcam(airportID: number, webcamID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/webcam/${webcamID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {Webcam} webcam
   * @return {any}
   * @private
   */
  _getWebcamJSON (webcam: Webcam): any {
    return {
      name: webcam.name,
      site: webcam.site,
      url: webcam.url,
      direction: webcam.direction,
      operatedBy: webcam.operatedBy
    };
  }
}
